/**
 * @generated SignedSource<<b2f3ebf6de63f0a4618739a197dac792>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteInvitationPayload",
    "kind": "LinkedField",
    "name": "deleteInvitation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteTeamInvitationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteTeamInvitationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8ef7003c3c915ce3997821bee8fa58f6",
    "id": null,
    "metadata": {},
    "name": "DeleteTeamInvitationMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteTeamInvitationMutation(\n  $input: DeleteInvitationInput!\n) {\n  deleteInvitation(input: $input) {\n    deletedId\n  }\n}\n"
  }
};
})();

node.hash = "d7a6127e82f44a3976c9c2e11fbf5c09";

export default node;
